import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilArray from "../../../utils/UtilArray.mjs";
import useUsuarioStore from "../stores/UsuarioStore";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async alterarStatus(statusNovo, requisicoesDeCompra = []){

        try{

            requisicoesDeCompra = requisicoesDeCompra.map((requisicaoDeCompra) => {

                return{
                    id: requisicaoDeCompra,
                    status: statusNovo,
                }
    
            });

            requisicoesDeCompra = await ERP.patchMany(Schema.REQUISICAO_DE_COMPRA, requisicoesDeCompra);
            if(requisicoesDeCompra.status != 200){
                throw requisicoesDeCompra;
            }

            console.log(requisicoesDeCompra);

        }catch(e){

            console.log(e);
            return requisicoesDeCompra;

        }

        return requisicoesDeCompra;

    },

    async criarRequisicoes(ordemDeServicoItens,comprador){

        let requisicoesDeCompra;
        let usuarioStore = useUsuarioStore();

        try{

            ordemDeServicoItens = ordemDeServicoItens.map((id)=>{

                return {
                    id: id,
                    status: "DC"
                }

            });

            ordemDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItens);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

            requisicoesDeCompra = ordemDeServicoItens.data.map((item) => {

                return{
                    status: "Em Desenvolvimento",
                    comprador: comprador.id,
                    ordemDeServicoItem: item.id,
                    dataCriacao: UtilDateTime.todayUTC(),
                    owners: UtilArray.unique(["23e308ed-4f67-4394-9a77-7228d2992dc3", usuarioStore.usuario.id, comprador.usuario])
                }
        
            });

            requisicoesDeCompra = await ERP.postMany(Schema.REQUISICAO_DE_COMPRA, requisicoesDeCompra);
            if(requisicoesDeCompra.status != 200){
                throw requisicoesDeCompra;
            }

            console.log(requisicoesDeCompra);

        }catch(e){

            console.log(e);
            return requisicoesDeCompra;

        }

        return requisicoesDeCompra;

    },

    async retornarRequisicoes(requisicoesDeCompra = []){

        try{

            requisicoesDeCompra = await this.alterarStatus("Cancelada", requisicoesDeCompra);
            if(requisicoesDeCompra.status != 200){
                throw requisicoesDeCompra;
            }

            let ordensDeServicoItens = requisicoesDeCompra.data.map(({ordemDeServicoItem}) => {

                return{
                    id: ordemDeServicoItem,
                    dataEntrega: "",
                    fornecedor: "",
                    fornecedorMaterialFornecido: "",
                    quantidadeCompra: 0,
                    unidadeCompra: null,
                    precoUnitarioComImpostos: 0,
                    precoUnitarioComImpostosPorcentagemDoDesconto: 0,
                    precoUnitarioComImpostosComDesconto: 0,
                    precoTotalComImpostos: 0,
                    temISS: false,
                    porcentagemISS: 0,
                    valorPIS: 0,
                    valorCOFINS: 0,
                    temICMS: false,
                    porcentagemICMS: 0,
                    valorICMS: 0,
                    temIPI: false,
                    porcentagemIPI: 0,
                    valorIPI: 0,
                    precoTotalSemImpostosComIPI: 0,
                    precoTotalComImpostosComIPI: 0,
                    status: "LC"
                }

            });

            ordensDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordensDeServicoItens);
            if(ordensDeServicoItens.status != 200){
                throw ordensDeServicoItens;
            }

        }catch(e){

            console.log(e);
            return requisicoesDeCompra;

        }

        return requisicoesDeCompra;

    }

}